import { brand } from "../../../../config/theme";

export type StatusCategory = "driving" | "ralenti" | "stopped" | "offline";

export const STATUS_ORDER: StatusCategory[] = [
  "driving",
  "ralenti",
  "stopped",
  "offline",
];

export const normalizeStatus = (
  status: string | null | undefined,
): StatusCategory => {
  const s = (status ?? "").toString().toLowerCase().trim();
  if (s === "driving" || s === "conduciendo") return "driving";
  if (s === "ralenti" || s === "ralentí" || s === "idle" || s === "sleep")
    return "ralenti";
  if (s === "stopped" || s === "stop" || s === "detenido" || s === "detenida")
    return "stopped";
  return "offline";
};

export const STATUS_COLOR: Record<StatusCategory, string> = {
  driving: brand.primary,
  ralenti: "#F59E0B",
  stopped: "#EF4444",
  offline: "#6B7280",
};

export const STATUS_LABEL: Record<StatusCategory, string> = {
  driving: "En movimiento",
  ralenti: "Ralentí",
  stopped: "Detenida",
  offline: "Sin conexión",
};

export const STATUS_FILTER_LABEL: Record<StatusCategory, string> = {
  driving: "En movimiento",
  ralenti: "Ralentí",
  stopped: "Detenidas",
  offline: "Sin conexión",
};

export const colorForStatus = (status: string | null | undefined): string =>
  STATUS_COLOR[normalizeStatus(status)];

export const labelForStatus = (status: string | null | undefined): string =>
  STATUS_LABEL[normalizeStatus(status)];

const hexToRgb = (hex: string): [number, number, number] => {
  let h = hex.replace("#", "");
  if (h.length === 3) {
    h = h
      .split("")
      .map((c) => c + c)
      .join("");
  }
  const int = parseInt(h, 16);
  if (Number.isNaN(int)) return [107, 114, 128];
  return [(int >> 16) & 255, (int >> 8) & 255, int & 255];
};

export const rgba = (hex: string, alpha: number): string => {
  const [r, g, b] = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const statusBadgeStyle = (
  status: string | null | undefined,
): { backgroundColor: string; color: string } => {
  const color = colorForStatus(status);
  return { backgroundColor: rgba(color, 0.16), color };
};
